import React from "react";
import {TableDateCell} from "../../../components/Table/TableDateCell.jsx";
import {Dropdown, Menu, Select} from "antd";
import {EllipsisOutlined} from "@ant-design/icons";
import {StringBuilder} from "../../../AppUtils.js";
import {ConfirmationRequiredWrapper, getStatus, OrderStatus, statusToTextAndColor} from "../../../components/index.jsx";
import "./delivery-provider-deliveries.css";
import {deliveriesPageSize, DeliveryProviderDeliveryStatusToText, DeliveryStatusToColor} from "./consts.jsx";
import {NOOP} from "../../../utils/NOOP.jsx";
import {BUDGET_LOAD_TRANSACTION} from "../../../orders/consts.jsx";

export const columns = (currentPage, options, drivers = [], onChangeDeliveryDriver) => {
    return [
        {
            title: "#",
            key: "#",
            width: 50,
            render(_, __, idx) {
                const realIndex = (currentPage - 1) * deliveriesPageSize + idx + 1;
                return `${realIndex}`;
            }
        },
        {
            title: "מספר הזמנה",
            width: 180,
            render(_, {proposalId}) {
                return proposalId;
            }
        },
        {
            title: "שם עסק",
            width: 180,
            render(_, {order}) {
                return order?.providerBrand;
            }
        },
        {
            title: "כתובת בית העסק",
            width: 180,
            render(_, {sourceAddress}) {
                return sourceAddress?.address;
            }
        },
        {
            title: "מסירה עיר",
            width: 180,
            render(_, {destinationAddress}) {
                return destinationAddress?.city;
            }
        },
        {
            title: "מסירה כתובת",
            width: 180,
            render(_, {destinationAddress}) {
                return destinationAddress?.address;
            }
        },
        {
            title: "טווח אספקה",
            dataIndex: "dtstart",
            width: 150,
            sorter: ({dtstart: r1}, {dtstart: r2}) => r1 - r2,
            render(startDate, {until}) {
                return startDate ? <TableDateCell date={startDate} endDate={until ?? startDate} /> : null;
            }
        },
        ...(onChangeDeliveryDriver
            ? [
                  {
                      title: "נהג",
                      width: 180,
                      render(_, {deliveryId, driverId}) {
                          return (
                              <Select
                                  className="drivers-select"
                                  value={driverId}
                                  placeholder="ציוות שליח"
                                  onSelect={selectedDriverId => onChangeDeliveryDriver(deliveryId, selectedDriverId)}>
                                  {drivers?.map(option => (
                                      <Select.Option key={option.driverId} value={option.driverId}>
                                          {option.name}
                                      </Select.Option>
                                  ))}
                              </Select>
                          );
                      }
                  }
              ]
            : []),
        {
            title: "סטטוס",
            width: 180,
            filters: [
                ...Object.entries(DeliveryStatusToColor).map(([key, value]) => {
                    const [color, backgroundColor] = value;

                    return {
                        text: <span style={{color}}>{DeliveryProviderDeliveryStatusToText[key]}</span>,
                        value: key
                    };
                })
            ],
            onFilter: (value, record) => value === record?.status,
            render(_, {status}) {
                return (
                    <span style={{color: DeliveryStatusToColor[status]?.[0]}}>
                        {DeliveryProviderDeliveryStatusToText[status]}
                    </span>
                );
            }
        },
        {
            title: "עלות משלוח",
            width: 180,
            render(_, {price}) {
                return new StringBuilder(price).append("₪").toString();
            }
        },
        ...(options?.length
            ? [
                  {
                      render(_, deliveryProvider) {
                          return (
                              <>
                                  <Dropdown
                                      overlay={
                                          <Menu>
                                              {options
                                                  ?.filter(({shouldShow}) =>
                                                      typeof shouldShow === "function"
                                                          ? shouldShow(deliveryProvider)
                                                          : true
                                                  )
                                                  ?.map(({title, onClick, needConfirmation}, index) => (
                                                      <>
                                                          {needConfirmation ? (
                                                              <Menu.Item key={index}>
                                                                  <ConfirmationRequiredWrapper
                                                                      onYes={() => onClick(deliveryProvider)}>
                                                                      {title}
                                                                  </ConfirmationRequiredWrapper>
                                                              </Menu.Item>
                                                          ) : (
                                                              <Menu.Item
                                                                  key={index}
                                                                  onClick={() => onClick(deliveryProvider)}>
                                                                  {title}
                                                              </Menu.Item>
                                                          )}
                                                      </>
                                                  ))}
                                          </Menu>
                                      }
                                      trigger={["click"]}>
                                      <EllipsisOutlined className="admin-orders-order-action-button" />
                                  </Dropdown>
                              </>
                          );
                      }
                  }
              ]
            : [])
    ];
};
